import React from 'react';
import styled, { css } from 'styled-components';
import { useStoreActions, useStoreState } from 'easy-peasy';

import { getSectorLabel, getQualificationLabel } from '~/utils';
import { colorScale, hexToRGB } from '~/components/Visualisation/chart-utils';

const PresetButtonsWrapper = styled.div`
  font-size: 14px;
`;

const GroupWrapper = styled.div``;

const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -3px;
`;

const PresetButton = styled.button`
  padding: 5px;
  margin: 3px;
  flex-shrink: 0;
  cursor: pointer;
  font-size: 14px;
  display: block;
  padding: 8px 15px;
  border: 1px solid rgb(221, 221, 221);
  background: rgb(238, 238, 238);
  outline: none;
  color: #999;
  user-select: none;

  ${(props) =>
    props.isActive
      ? css`
          background: ${(props) => props.theme.colors.blue};
          color: white;
          border-color: ${(props) => props.theme.colors.blue};
          font-weight: bold;
        `
      : ''}

  &:hover {
    background: ${(props) => props.theme.colors.blue};
    color: white;
  }
`;

const HiddenFakeLabel = styled.span`
  display: block;
  height: 0px;
  overflow: hidden;
  font-size: 14px;
  font-weight: bold;
  opacity: 0;
  visibility: hidden;
`;

const GroupLabel = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  margin-top: 3px;
  margin-bottom: 3px;
`;

const MainLabel = styled(GroupLabel)`
  text-transform: none;
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: bold;
`;

const Option = ({ label, onClick = () => {}, isActive = false }) => (
  <PresetButton isActive={isActive} onClick={onClick}>
    {label}
    <HiddenFakeLabel>{label}</HiddenFakeLabel>
  </PresetButton>
);

const DemographicsFilter = ({ label, value }) => {
  const setFilterDemographics = useStoreActions(
    (actions) => actions.app.setFilterDemographics
  );
  const filterDemographics = useStoreState(
    (actions) => actions.app.filterDemographics
  );

  return (
    <Option
      onClick={() => setFilterDemographics(value)}
      label={label}
      isActive={filterDemographics === value}
    />
  );
};

const QualificationButton = styled(PresetButton)`
  background: ${(p) => hexToRGB(p.color, 0.2)};
  border-color: ${(p) => p.color};
  color: ${(p) => p.color};

  ${(props) =>
    props.isActive
      ? css`
          background: ${(props) => props.color};
          color: white;
          border-color: ${(props) => props.color};
          font-weight: bold;
        `
      : ''}

  &:hover {
    background: ${(props) => props.color};
    color: white;
  }
`;

const QualificationOption = ({
  label,
  onClick = () => {},
  isActive = false,
  color,
}) => (
  <QualificationButton isActive={isActive} onClick={onClick} color={color}>
    {label}
    <HiddenFakeLabel>{label}</HiddenFakeLabel>
  </QualificationButton>
);

const QualificationFilter = ({ value }) => {
  const setFilterQualification = useStoreActions(
    (actions) => actions.app.setFilterQualification
  );
  const filterQualification = useStoreState(
    (actions) => actions.app.filterQualification
  );

  const label = getQualificationLabel(value);
  const isActive = filterQualification === value;
  const onClick = () => setFilterQualification(value);

  if (value === null) {
    return <Option onClick={onClick} label={label} isActive={isActive} />;
  }

  return (
    <QualificationOption
      onClick={onClick}
      label={label}
      isActive={isActive}
      color={value !== null ? colorScale(value) : '#0069b4'}
    />
  );
};

const SectorFilter = ({ value }) => {
  const setFilterSector = useStoreActions(
    (actions) => actions.app.setFilterSector
  );
  const filterSector = useStoreState((actions) => actions.app.filterSector);

  return (
    <Option
      onClick={() => setFilterSector(value)}
      label={getSectorLabel(value)}
      isActive={filterSector === value}
    />
  );
};

const FilterButtons = () => {
  const setTooltipData = useStoreActions(
    (actions) => actions.tooltip.setTooltipData
  );

  return (
    <PresetButtonsWrapper onClick={() => setTooltipData(null)}>
      <GroupWrapper>
        <MainLabel>Qualifikation auswählen</MainLabel>
        <ButtonWrapper>
          <QualificationFilter value={null} />
          <QualificationFilter value="Helfer" />
          <QualificationFilter value="Fachkraft" />
          <QualificationFilter value="Spezialist" />
          <QualificationFilter value="Experte" />
        </ButtonWrapper>
      </GroupWrapper>
      <GroupWrapper>
        <MainLabel>
          Untergruppe auswählen (ändert Löhne und Beschäftigte)
        </MainLabel>
        <ButtonWrapper>
          <DemographicsFilter value="all" label="Alle" />
          <DemographicsFilter value="female" label="Frauen" />
          <DemographicsFilter value="male" label="Männer" />
          <DemographicsFilter value="under40" label="unter 30 Jahren" />
          <DemographicsFilter value="over40" label="über 30 Jahren" />
          <DemographicsFilter value="south" label="Süddeutschland" />
          <DemographicsFilter value="west" label="Nord- und Westdeutschland" />
          <DemographicsFilter value="east" label="Ostdeutschland" />
        </ButtonWrapper>
      </GroupWrapper>
      <GroupWrapper>
        <MainLabel>Sektor auswählen</MainLabel>
        <ButtonWrapper>
          <SectorFilter value={null} label="Alle" />
          <SectorFilter value={1} />
          <SectorFilter value={2} />
          <SectorFilter value={3} />
          <SectorFilter value={4} />
          <SectorFilter value={5} />
          <SectorFilter value={6} />
          {/* <SectorFilter value={7} /> */}
          <SectorFilter value={8} />
          <SectorFilter value={9} />
        </ButtonWrapper>
      </GroupWrapper>
    </PresetButtonsWrapper>
  );
};

export default FilterButtons;
